// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1cU4x","itemTitle":"ClientEmergencyInfo_itemTitle__2Lk5A","itemText":"ClientEmergencyInfo_itemText__3IBk3"};